import * as React from 'react';
import { COLOR } from '@src/styles/color';
import { useSelector } from 'react-redux';
import { StyledIconButton } from '@src/containers/TTSNew/NewRequest/index.style';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useTranslation } from 'react-i18next';
import { CustomTablePagination, StyledNewPagination } from './index.style';

export default function TableFooterNew({
  rowsPerPage,
  onChangeRowPage,
  page,
  total,
  onChangePage,
  rowsPerPageOptions = [5, 10, 25],
  disabledButton,
  styleFooter,
  styleSelect,
  minWidth,
}) {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const handleChangePage = (event, newPage) => {
    onChangePage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    onChangeRowPage(parseInt(event.target.value, 10));
    onChangePage(0);
  };
  const { showAudioPlayer } = useSelector((state) => state.audioPlayer);
  const totalPages = Math.ceil(total / rowsPerPage);
  const theme = createTheme({
    components: {
      MuiMenu: {
        styleOverrides: {
          root: {
            '& .MuiList-root': {
              padding: '4px 0px',
            },
            '& .MuiPaper-elevation': {
              borderRadius: '4px',
              width: '75px',
            },
            '& .MuiMenuItem-root': {
              color: COLOR.darkBlue,
              fontWeight: 400,
              display: 'block',
              fontSize: 14,
              '&:focus': {
                backgroundColor: COLOR.activeMenu,
              },
              '&:hover': {
                backgroundColor: COLOR.activeMenu,
              },
              '&.Mui-selected': {
                backgroundColor: COLOR.activeMenu,
                '&:hover': {
                  backgroundColor: COLOR.activeMenu,
                },
              },
              textAlign: 'center',
            },
          },
        },
      },
    },
  });
  const newActionBtn = React.useCallback(
    ({ onPageChange }) => (
      <>
        <StyledIconButton
          height="40px"
          width="40px"
          padding="12px"
          className="prevBtn"
          onClick={(event) => {
            if (page === 0 || disabledButton) return;
            onPageChange(event, page - 1);
          }}
        >
          <KeyboardArrowLeftRoundedIcon />
        </StyledIconButton>
        <StyledIconButton
          height="40px"
          width="40px"
          padding="12px"
          className="nextBtn"
          onClick={(event) => {
            if (page === totalPages - 1 || disabledButton) return;
            onPageChange(event, page + 1);
          }}
        >
          <ChevronRightRoundedIcon />
        </StyledIconButton>
      </>
    ),
    [page, totalPages],
  );
  return (
    <ThemeProvider theme={theme}>
      <StyledNewPagination
        isDisabledPrev={page === 0 || disabledButton}
        isDisabledNext={page === totalPages - 1 || disabledButton}
        styleFooter={styleFooter}
        style={{ minWidth }}
      >
        <CustomTablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          count={total}
          SelectProps={{
            IconComponent: ArrowDropDownRoundedIcon,
            MenuProps: {
              PaperProps: {
                style: {
                  transform: showAudioPlayer
                    ? 'translateX(5%) translateY(-124%)'
                    : 'translateX(5%) translateY(-50%)',
                  ...(styleSelect && styleSelect),
                },
              },
            },
            style: {
              width: '75px',
              height: '40px',
              padding: '8px 8px 8px 2px',
              boxSizing: 'border-box',
              borderRadius: '8px',
              border: '1px solid #3C3C4329',
            },
          }}
          rowsPerPage={rowsPerPage}
          component="div"
          page={page}
          labelRowsPerPage={t('perRequestOnPage')}
          labelDisplayedRows={({ from, to, count }) =>
            `${from?.toLocaleString(language)}-${to?.toLocaleString(
              language,
            )} ${t('inside')} ${count?.toLocaleString()}`
          }
          ActionsComponent={newActionBtn}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          style={{ minWidth }}
        />
      </StyledNewPagination>
    </ThemeProvider>
  );
}
